module.exports = __webpack_public_path__ + "static/logo_blue-0647b59a8cda4488c8af6cae03d12a2c.svg";